import { DefaultState, IState } from "./state";
import { Keys, Types } from "./actions/types";
import { access } from "../../../model/access";
// import { reminder, emptyReminder } from '../../../model/reminder';

// const sanifyContact = (c: contact): contact => {
//     let s = emptyContact();
//     Object.keys(c).forEach(key => {
//         if (c[key]) {
//             s[key] = c[key];
//         }
//     })
//     return s;
// }

export const reducer = (state: IState = DefaultState(), action: Types): IState => {
    switch (action.type) {
        case Keys.LOADACCESSES_PENDING: {
            return {
                ...state,
                accesses: [],
                isLoadingAccesses: true,
            }
        }
        case Keys.LOADACCESSES_FULFILLED: {
            let p: Array<access> = action.payload;
            return {
                ...state,
                accesses: p,
                isLoadingAccesses: false,
            }
        }
        case Keys.LOADACCESSES_REJECTED: {
            return {
                ...state,
                accesses: [],
                isLoadingAccesses: false,
            }
        }
        case Keys.LOADPASSAGES_PENDING: {
            return {
                ...state,
                selectedContactAccesses: [],
                isLoadingAccesses: true,
            }
        }
        case Keys.LOADPASSAGES_FULFILLED: {
            let p: Array<access> = action.payload;
            return {
                ...state,
                selectedContactAccesses: p,
                isLoadingAccesses: false,
            }
        }
        case Keys.LOADPASSAGES_REJECTED: {
            return {
                ...state,
                selectedContactAccesses: [],
                isLoadingAccesses: false,
            }
        }
        default:
            return state;
    }
}